module.exports = __webpack_public_path__ + "img/Logo_Finis_Terrae.ff8092e0.png";